import { NgModule } from "@angular/core";
import { StoreModule } from "@ngrx/store";
import { PaymentCheckRouter } from "./payment-check.router";
import { reducers } from "./state/payment-check.selectors";

@NgModule({
  imports: [
    PaymentCheckRouter,
    StoreModule.forFeature('paymentCheck', reducers),
  ],
  declarations: []
})
export class PaymentCheckScreenModule { }